import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import THEME_COLORS from '@/scss/export.scss';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: THEME_COLORS,
    },
  },
});
